<template>
  <div class="public-content">
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="left-content">
          <div class="content-box setting-box">
            <div class="sub-head">
              <span>设置</span>
              <el-button type="primary" size="small" class="operation-btn" v-if="communityInfo.initid"
                @click="delRelate">注销</el-button>
              <el-button type="primary" size="small" class="operation-btn" v-else @click="relate">绑定本单位公众号</el-button>
            </div>
            <div class="setting-info">
              <img src="@/assets/images/avatar_pic_community_n.png" alt v-if="!communityInfo.initid" />
              <img :src="communityInfo.head_img" alt />
              <div v-if="communityInfo.initid">
                <span>{{communityInfo.gzhmingc}}</span>
                <p>APPID:{{communityInfo.gzhappid}}</p>
                <p>原始ID: {{communityInfo.initid}}</p>
                <p>账号类型:{{communityInfo.gzhleixing==='2'?'服务号' : '订阅号'}}</p>
              </div>
              <div v-else class="tips">
                <p>您还没有绑定·公众号！</p>
                <p>绑定后可以显示账号信息</p>
              </div>
            </div>
          </div>
          <div class="content-box message-box">
            <div class="sub-head">
              <span>自动回复</span>
            </div>
            <div class="message-info" v-if="communityInfo.initid">
              <div class="message-item">
                <div>关注回复</div>
                <div>
                  <el-input v-model.trim="hyyInfo.body" placeholder="请填写回复语！" size="small" @blur="addAnswer"
                    @keyup.enter.native="addAnswer"></el-input>
                </div>
              </div>
              <div class="message-item">
                <div>消息回复</div>
                <div class="tips">消息回复功能正在开发</div>
              </div>
              <div class="message-item">
                <div>关键词</div>
                <div class="tips">消息回复功能正在开发</div>
              </div>
            </div>
            <div v-else class="tips message-tip">
              <div>
                <p>您还没有绑定·公众号！</p>
                <p>绑定后可以设置自动回复</p>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="content-box menu-box">
          <div class="sub-head">
            <span>菜单设置</span>
            <div>
              <el-popover placement="bottom" width="120" trigger="click" :disabled="!communityInfo.initid">
                <div class="code-box">
                  <img :src="codeImg" alt class="codeImg" />
                  <p @click="downloadCode">下载</p>
                </div>
                <el-button slot="reference" :disabled="!communityInfo.initid" type="text">公众号二维码</el-button>
              </el-popover>
            </div>
          </div>
          <div class="menu-box">
            <div class="menuInfo">
              <div class="keyboard">
                <img src="@/assets/images/wxmenu.png" alt />
              </div>
              <div class="menuList" v-for="(item,index) in menu" :key="index">
                <el-popover placement="top" width="150" trigger="hover" class="menu-tooltip">
                  <div class="publicMenu-tree">
                    <el-tree :data="item.children" :props="defaultProps" draggable :allow-drop="allowDrop"
                      @node-drag-end="handleDragEnd" @node-click="(data)=>{editSecondMenu(data,index)}"></el-tree>
                  </div>
                  <div class="menuAdd-btn" @click="addSecondMenu(index)"
                    v-if="!item.children || item.children.length<=5">
                    <i class="el-icon-plus"></i>
                  </div>
                  <div class="publicTab" slot="reference" @click="editFirstMenu(item,index)">
                    <i class="el-icon-more"></i>
                    <span>{{item.name}}</span>
                  </div>
                </el-popover>
              </div>
              <div class="menuList" v-if="menu.length<3">
                <el-button class="publicTab" @click="addFirstMenu" :disabled="!communityInfo.initid">
                  <i class="el-icon-plus"></i>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="菜单名称" :visible.sync="dialogFormVisible" width="50%" class="add-dialog" @open="addDiaOpen" @close="addDiaClose('menuform')">
      <el-form :model="detailInfo" :rules="rules" ref="menuform">
        <el-form-item label="菜单名称" class="nameInput" prop="name">
          <el-input v-model="detailInfo.name" autocomplete="off" size="small"></el-input>
        </el-form-item>
        <el-form-item label="菜单内容" prop="type">
          <el-radio-group v-model="detailInfo.type" @change="typeChange">
            <el-radio label="view">跳转网页</el-radio>
            <el-radio label="miniprogram">小程序</el-radio>
            <el-radio label="media_id">图文消息</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <div class="typeInfo">
            <div v-if="detailInfo.type==='view'">
              <p>订阅者点击该子菜单会跳到以下链接</p>
              <el-form-item label="链接地址" prop="url">
                <el-input v-model="detailInfo.url" autocomplete="off" size="small"></el-input>
              </el-form-item>
              <p>常用链接</p>
              <el-form-item prop="url">
                <el-radio-group v-model="detailInfo.url" >
                  <el-radio :label="item.url" v-for="(item,index) in pageLinkList" :key="index">{{item.urlname}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-if="detailInfo.type==='miniprogram'" class="wxLink-box">
              <div class="wxInfo">
                <img src="@/assets/images/logo.png" alt />
                <p>聚合信息</p>
                <el-button type="primary" size="small" v-if="!isLinkWechat" @click="linkWechat">关联</el-button>
                <el-button type="primary" size="small" v-else @click="cancelLink">取消关联</el-button>
              </div>
              <div v-if="isLinkWechat">
                <el-form-item label="链接地址" prop="pagepath">
                  <el-input v-model="detailInfo.pagepath" autocomplete="off" size="small"></el-input>
                </el-form-item>
                <p>常用链接</p>
                <el-form-item prop="pagepath">
                  <el-radio-group v-model="detailInfo.pagepath">
                    <el-radio :label="item.url" v-for="(item,index) in wechatLinkList" :key="index">{{item.urlname}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
            <div v-if="detailInfo.type==='media_id'"></div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteMenu">删除菜单</el-button>
        <el-button type="primary" @click="saveMenu('menuform')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="聚合信息" :visible.sync="firstMenuVisible" width="50%" class="add-dialog">
      <p>已添加子菜单，仅可设置菜单名称</p>
      <el-form :model="firstMenu" :rules="firstMenuRules" ref="firstMenuform">
        <el-form-item label="菜单名称" class="nameInput" prop="name">
          <el-input v-model="firstMenu.name" autocomplete="off" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteMenu">删除菜单</el-button>
        <el-button type="primary" @click="changeName('firstMenuform')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import api from "@/api/news/publish.js";
  export default {
    data() {

      var validateMedia = (rule, value, callback) => {
        if (this.detailInfo.type === "media_id" && value === '') {
          callback(new Error('请输入链接'));
        } else {
          callback();
        }
      };

      var validateView = (rule, value, callback) => {
        if (this.detailInfo.type === "view" && value === '') {
          callback(new Error('请输入链接'));
        } else {
          callback();
        }
      };

      var validateMini = (rule, value, callback) => {
        if (this.detailInfo.type === "miniprogram" && value === '') {
          callback(new Error('请输入链接'));
        } else {
          callback();
        }
      };
      return {
        hyyInfo: {
          body: "",
          id: 0
        },
        codeImg: "",
        urlPre: "",
        // 菜单相关
        menu: [],
        isLinkWechat: false,
        dialogFormVisible: false,
        pageLinkList: [],
        wechatLinkList: [],
        detailInfo: {
          name: "",
          type: "view",
          url: "",
          pagepath: "",
          mediaid: ""
        },
        firstMenuVisible: false,
        firstMenu: {
          name: ""
        },
        firstMenuRules: {
          name: [{ required: true, message: "请输入子菜单名称", trigger: "blur" }]
        },
        rules: {
          name: [
            { required: true, message: "请输入子菜单名称", trigger: "blur" }
          ],
          url: [{ validator: validateView, trigger: 'blur' }],
          pagepath: [{ validator: validateMini, trigger: 'blur' }],
          media_id: [{ validator: validateMedia, trigger: 'blur' }],
          type: [
            { required: true, message: "请选择子菜单类型", trigger: "change" }
          ]
        },
        defaultProps: {
          label: "name"
        },
        fistIndex: 0,
        secondIndex: "",
        editType: 0 // 0 编辑一级菜单 ， 1 编辑二级菜单
      };
    },
    computed: {
      token() {
        return this.$store.state.token;
      },
      userInfo() {
        return this.$store.state.userInfo;
      },
      communityInfo() {
        return this.$store.state.communityInfo;
      },
      plusNum() {
        return 3 - this.menu.length;
      }
    },
    mounted() {
      let baseURL = this.$http.defaults.baseURL;
      this.urlPre = baseURL.substr(0, baseURL.lastIndexOf(":")) + "/bkvito";
      // 获取回复
      this.gethyy();
      // 获取code
      this.getCode();
      // 获取菜单信息
      this.getMenu();
    },
    methods: {
      // 获取欢迎语
      async gethyy() {
        if (!this.communityInfo.initid) return;
        let res = await this.$http.get(
          `${api.gethyy}?initid=${this.communityInfo.initid}`
        );
        if (res && res.isSucceed) {
          this.hyyInfo.body =
            res.rows && res.rows.length > 0 ? res.rows[0].body : "";
          this.hyyInfo.id = res.rows && res.rows.length > 0 ? res.rows[0].id : "";
        }
      },
      // 获取二维码图片
      async getCode() {
        if (!this.communityInfo.initid) return;
        let data = {
          initid: this.communityInfo.initid,
          code: "SubCode"
        };
        let res = await this.$http.get(api.getCode, { params: data });
        if (res && res.isSucceed) {
          this.codeImg = res.rows && res.rows.length > 0 ? res.rows[0] : "";
        }
      },
      // 获取菜单信息
      async getMenu() {
        if (!this.communityInfo.initid) return;
        let res = await this.$http.post(
          api.getMenu,
          this.$qs.stringify({ initid: this.communityInfo.initid })
        );
        if (res && res.isSucceed) {
          let menu =
            res.rows && res.rows.length > 0 ? res.rows[0].menucontent : "";
          this.menu = menu ? JSON.parse(menu) : [];
          this.addMenuId(this.menu);
        }
      },
      addMenuId(data) {
        for (let i = 0; i < data.length; i++) {
          data[i].treeId = i;
          if (data[i].children && data[i].children.length > 0) {
            this.addMenuId(data[i].children);
          }
        }
      },
      //// 获取关联网页及小程序页面列表
      async linkUrl(type) {
        let res = await this.$http.get(`${api.linkUrl}?urltype=${type}`);
        if (res && res.isSucceed) {
          if (type === "common_use_link") {
            this.pageLinkList = res.rows;
          }
          if (type === "bkkj_miniprogram_link") {
            this.wechatLinkList = res.rows;
          }
        }
      },
      //// 获取关联网页及小程序页面列表
      async getArticleList(type) {
        let data = {
          communityid: this.userInfo.communityId,
          articletypeids: '',
          articletitle: '',
          // page: 0,
          type: ''
        }
        let res = await this.$http.get(api.articleList, { params: data })
        if (res && res.isSucceed) {
          this.articleList = res.rows;
        }
      },
      // 查看是否关联小程序
      async checkLinkWechat() {
        if (!this.communityInfo.initid) return;
        let data = {
          initid: this.communityInfo.initid,
          appId: "wxa0727b7f184f6259",
          miniProgramInitid: "gh_39dc3294151c"
        };
        let res = await this.$http.get(api.checkLinkWechat, { params: data });
        if (res && res.isSucceed) {
          this.isLinkWechat =
            res.message === "公众号与小程序已关联" || "已关联" ? true : false;
        }
      },
      // 关联小程序
      async linkWechat() {
        if (!this.communityInfo.initid) return;
        let data = {
          initid: this.communityInfo.initid,
          appId: "wxa0727b7f184f6259"
        };
        let res = await this.$http.get(api.linkWechat, { params: data });
        if (res && res.isSucceed) {
          _this.checkLinkWechat();
          this.isLinkWechat = true;
          this.$message({
            type: "success",
            message: "关联成功"
          });
        }
      },
      // 取消关联小程序
      cancelLink() {
        let _this = this;
        _this
          .$confirm(
            "该行为将删除所有跳转'聚合信息'小程序的菜单,是否继续取消关联?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
          .then(async () => {
            if (!this.communityInfo.initid) return;
            let data = {
              initid: this.communityInfo.initid,
              appId: "wxa0727b7f184f6259"
            };
            let res = await this.$http.post(
              api.cancelLink,
              this.$qs.stringify(data)
            );
            if (res && res.isSucceed) {
              _this.checkLinkWechat();
            }
          });
      },
      // 绑定公众号
      async relate() {
        let res = await this.$http.get(`${this.urlPre}${api.relate}`);
        if (res && res.isSucceed) {
          window.location.href = res.rows[0];
        }
      },
      // 注销
      delRelate() {
        let _this = this;
        _this
          .$confirm("删除后该账号的所有设置（粉丝、菜单）都将清除", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(async () => {
            if (!this.communityInfo.initid) return;
            let data = {
              initid: this.communityInfo.initid,
              orgid: this.communityInfo.orgid,
              orgpath: this.communityInfo.orgpath
            };
            let res = await this.$http.post(
              api.delRelate,
              this.$qs.stringify(data)
            );
            if (res && res.isSucceed) {
              this.$store.commit("DEL_COMMUNITY");
              _this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
      },
      // 添加欢迎语
      async addAnswer() {
        if (!this.communityInfo.initid) return;
        let data = {
          type: 0,
          body: this.hyyInfo.body,
          initid: this.communityInfo.initid,
          id: this.hyyInfo.id
        };
        let res = await this.$http.post(api.addAnswer, this.$qs.stringify(data));
        if (res && res.isSucceed) {
          this.hyyInfo.id = res.newPrimaryKeys.id;
          this.gethyy();
        }
      },
      // 下载二维码
      downloadCode() {
        if (!this.communityInfo.initid) return;
        window.location.href = `${this.urlPre}${api.downloadCode}?initid=${this.communityInfo.initid}&token=${this.token}`;
      },
      // 避免相同层级嵌套
      allowDrop(draggingNode, dropNode, type) {
        return type !== "inner";
      },
      typeChange(val) {
        this.detailInfo.url = val === 'view' ? this.detailInfo.url : ''
        this.detailInfo.pagepath = val === 'miniprogram' ? this.detailInfo.pagepath : ''
        this.detailInfo.appId = val === 'miniprogram' ? 'wxa0727b7f184f6259' : ''
        this.detailInfo.mediaid = val === 'media_id' ? this.detailInfo.mediaid : ''
      },
      // 弹窗打开获取数据
      addDiaOpen() {
        // 常见网页列表
        this.linkUrl("common_use_link");

        // 常见小程序列表
        this.linkUrl("bkkj_miniprogram_link");

        // 图文列表
        // this.getArticleList();

        // 查看是否关联小程序
        this.checkLinkWechat();
      },
      addDiaClose(formName){
        this.$refs[formName].resetFields();
        this.detailInfo={
          name: "",
          type: "view",
          url: "",
          pagepath: "",
          mediaid: ""
        }
      },
      // 拖拽完成
      handleDragEnd() {
        this.submit(this.menu);
      },
      addFirstMenu(index) {
        if (this.menu && this.menu.length >= 3) return false;
        this.menu.push({ name: "一级菜单", treeId: this.menu.length });
      },
      editFirstMenu(data, index) {
        this.fistIndex = index;
        this.editType = 0;
        if (data.children && data.children.length > 0) {
          Object.assign(this.firstMenu, data);
          if (this.$refs.firstMenuform !== undefined) {
            this.$refs.firstMenuform.clearValidate();
          }
          this.firstMenuVisible = true;
        } else {
          Object.assign(this.detailInfo, data);
          if (this.$refs.menuform !== undefined) {
            this.$refs.menuform.clearValidate();
          }
          this.dialogFormVisible = true;
        }
      },
      // 点击添加符号，打开弹窗
      addSecondMenu(index) {
        if (!this.menu[index].children || this.menu[index].children.length <= 0) {
          this.$set(this.menu[index], "children", []);
        }
        this.menu[index].children.push({
          name: "子菜单名称",
          treeId: this.menu[index].children.length
        });
      },
      editSecondMenu(data, index) {
        this.editType = 1;
        this.secondIndex = data.treeId;
        this.fistIndex = index;
        Object.assign(this.detailInfo, data);
        if (this.$refs.menuform !== undefined) {
          this.$refs.menuform.clearValidate();
        }
        this.dialogFormVisible = true;
      },

      changeName(formName) {
        this.$refs[formName].validate(async valid => {
          if (!valid) return false;
          let menuData = JSON.parse(JSON.stringify(this.menu));
          menuData[this.fistIndex].name = this.firstMenu.name;
          await this.submit(menuData);
          this.firstMenuVisible = false;
        });
      },

      // 删除菜单
      deleteMenu() {
        let menuData = JSON.parse(JSON.stringify(this.menu));
        if (this.editType) {
          menuData[this.fistIndex].children.splice(this.secondIndex, 1);
        } else {
          menuData.splice(this.fistIndex, 1);
        }
        this.submit(menuData,true);
        this.dialogFormVisible = false;
        this.firstMenuVisible = false;
      },
      // 保存菜单
      saveMenu(formName) {
        this.$refs[formName].validate(async valid => {
          if (!valid) return false;
          let menuData = JSON.parse(JSON.stringify(this.menu));
          if (this.editType) {
            Object.assign(
              menuData[this.fistIndex].children[this.secondIndex],
              this.detailInfo
            );
          } else {
            Object.assign(menuData[this.fistIndex], this.detailInfo);
          }
          await this.submit(menuData);
          this.dialogFormVisible = false;
        });
      },
      deleteMenuId(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].treeId !== undefined && data[i].treeId !== "") {
            delete data[i].treeId;
          }
          if (data[i].children && data[i].children.length > 0) {
            this.deleteMenuId(data[i].children);
          }
        }
      },
      async submit(menuData,isDelete) {
        this.deleteMenuId(menuData);
        if (!this.communityInfo.initid) return;
        let data = {
          wmenu: JSON.stringify(menuData),
          initid: this.communityInfo.initid
        };
        let res = await this.$http.post(api.saveMenu, this.$qs.stringify(data));
        if (res && res.isSucceed) {
          if(isDelete){
            this.$message({
              type:'success',
              message:'删除成功',
            })
          }
          this.getMenu();
        }
      }
    }
  };
</script>
<style lang='less' scoped>
  @import url("./index.less");
</style>
<style lang='less'>
  .el-popover {
    padding: 0px !important;
    text-align: center;
    background: #f4f4f4;
  }

  .publicMenu-tree {
    .el-tree {
      background: #f4f4f4;
    }

    .el-tree__empty-block,
    .el-tree-node__content {
      background: #f4f4f4;
      text-align: center;
      height: 50px;
      justify-content: space-between;
      border-bottom: 1px solid rgb(215, 221, 228);

      .el-tree-node__expand-icon {
        display: none;
      }

      &>span:nth-child(2) {
        flex: 1;
      }
    }
  }

  .public-content {
    .add-dialog {
      .el-radio-group {
        label {
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }
</style>